export default "__VITE_ASSET__BOybNrhV__"